// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GdeL","colMin":"styles_colMin__1bGsm"};